module.exports = {
	"general.formats.dayFormattingPattern": "MMMM DD, YYYY",
	"general.formats.datePatternAPI": "YYYY-MM-DD",
	"general.formats.datePatternUI": "MM-DD-YYYY",
	"general.formats.shortDatePattern": "MMM DD",
	"general.formats.fullShortDatePattern": "MMM DD, YYYY",
	"general.formats.timePattern": "hh:mm a",
	"general.title": "{brandName}",
	"general.description": "醫院以外的醫療護理",
	"general.slogan.primary": "一個提高患者參與的全球網",
	"general.slogan.secondary": "緊密聯絡 無間合作",
	"general.labels.you": "(你)",
	"general.labels.YO": "歲",
	"general.labels.noInternet": "沒有網絡連接",
	"general.labels.myProfile": "我的個人資訊",
	"general.labels.profile": "個人資訊",
	"general.labels.backToInvitation": "回到邀請階段",
	"general.labels.userNameExample": "JohnDoe_123 or Wolverine",
	"general.labels.userNameExplanation": "暱稱是你發帖的筆名，如果你比較喜歡匿名的話可以挑有創意的",
	"general.labels.pickItemLeft": "在左側欄選一項查看",
	"general.errors.404": "噢! 這沒什麼可看的.",
	"general.toTop": "回到頁頂",
	"general.success": "成功",
	"general.removedFromChat": "你已離開這群組",
	"general.search.placeholder": "找尋...",
	"general.search.patients": "找尋病人...",
	"common.remove": "刪除",
	"common.unassign": "未分派",
	"common.accept": "接受",
	"common.decline": "拒絕",
	"common.back": "回去",
	"common.cancel": "取消",
	"common.save": "保存",
	"common.invite": "送出邀請",
	"common.terms": "服務條款",
	"common.yes": "是",
	"common.add": "加",
	"common.no": "否",
	"common.close": "關閉",
	"common.clear": "清除",
	"common.collapse": "折叠",
	"common.myMessages": "我的主版",
	"common.myCommunities": "我的社區",
	"common.optional": "(非強制性)",
	"menu.healthboard": "主版",
	"menu.myCircles": "我的圈",
	"menu.communities": "社區",
	"messages.chat.searchByPeopleUsername": "以用戶名尋找…",
	"messages.chat.enterUsernameOrName": "輸入用戶名或姓名來開始對話",
	"messages.chat.newChat": "新對話",
	"messages.chat.findAMember": "找成員",
	"messages.chat.youAddedMembers": "你已加了 {counter} {counter, plural, one {位成員} other {位成員}}",
	"messages.chat.counterMembers": "{counter} {counter, plural, one {位成員} other {位成員}}",
	"messages.chat.startANewConversationInTheContextOf": "開始一個圍繞{user}的對話",
	"messages.chat.startANewConversationInTheContextOfDesc": "下列是醫療護理圈成員。你可以尋找並加入新成員",
	"messages.chat.startANewConversation": "開始對話",
	"messages.chat.start": "開始",
	"messages.chat.noOneFound": "沒有你找的人",
	"messages.chat.empty.messages": "你沒有訊息",
	"messages.chat.empty.users": "沒有用戶可以對話",
	"messages.chat.empty.channels": "沒有可連接的渠道",
	"messages.chat.searchAUser": "尋找用戶...",
	"messages.chat.defaultUser": "輸入用戶名或姓名來加入對話",
	"messages.userProfile.familyMembers": "家庭成員",
	"messages.userProfile.programServiceProviders": "計劃/服務提供者",
	"messages.userProfile.singleProvider": "單一醫療護理人員",
	"messages.userProfile.mainProvider": "主要醫療護理人員",
	"messages.userProfile.memberProviderCircle": "成員",
	"messages.titles.familyTitleWithCounter": "家庭圈 ({counter})",
	"messages.titles.providerTitleWithCounter": "醫療護理圈 ({counter})",
	"messages.nav.tabs.patient": "一般 用戶",
	"messages.nav.tabs.provider": "醫療護理人員",
	"messages.filterOptions.allPatients": "所有病人",
	"messages.filterOptions.myPatients": "我的病人",
	"messages.statusFilterOptions.all": "所有",
	"messages.statusFilterOptions.joined": "已加入",
	"messages.statusFilterOptions.notJoined": "未加入",
	"messages.patientNotJoined.message": "病人還未加入",
	"messages.patientNotJoined.resend": "再次邀請",
	"messages.patientNotJoined.invite": "送出邀請",
	"messages.patientNotJoined.inviteSent": "邀請已送出",
	"messages.patientNotJoined.checkContactInformationText": "送出邀請前請確認病人聯絡細節",
	"messages.patientNotJoined.inviteTitle": "邀請病人",
	"messages.patientNotJoined.errors.emailAlreadyTaken": "此電郵地址已被佔用，請另選一個",
	"messages.patientNotJoined.errors.emailInvalid": "此電郵地址並不正確 請另選一個",
	"messages.patientNotJoined.errors.emailBlank": "電郵地址不能空白",
	"messages.patientNotJoined.errors.phoneNumberAlreadyTaken": "電話號碼已被佔用，請另選一個",
	"messages.patientNotJoined.errors.phoneNumberBlank": "電話號碼不能空白",
	"messages.patientNotJoined.errors.phoneNumberInvalid": "此電話號碼並不正確",
	"messages.titles.accessLevel": "使用級別",
	"messages.titles.accessLevelTooltip": "臨時開通使用30分鐘",
	"messages.titles.reasonForAssignment": "分派理由",
	"messages.titles.selectReasonForAssignment": "請選擇分派理由",
	"circle.assigned": "成功分派醫療護理人員",
	"circle.unassigned": "成功取消醫療護理人員分派",
	"circle.confirmUnassigned": "對不起，你不能進入因他已不是你的病人",
	"circle.notInCircle": "不再{contextUser}的醫療護理圈",
	"circles.empty": "你未有圈子",
	"circles.empty.navigation": "沒有圈子可供瀏覽",
	"circles.invites.cancelInvite": "取消邀請",
	"circles.invites.confirmCancel": "是, 確定",
	"circles.invites.declineCancel": "否",
	"circles.invites.inviteSent": "邀請已送出",
	"circles.invites.invitedCaregiver": "護理員 (待定)",
	"circles.invites.family.success": "家庭成員邀請已送出",
	"circles.invites.caregiver.success": "護理人員邀請已送出",
	"circles.invites.provider.success": "醫療護理人員已加入圈子",
	"circles.invites.family.accept": "你已接受加入家庭圈",
	"circles.invites.family.decline": "你拒絕了加入家庭圈的邀請",
	"circles.invites.caregiver.accept": "你已接受成為護理員",
	"circles.invites.caregiver.decline": "你拒絕了成為護理員",
	"circles.provider.remove": "此人已從你的醫療護理圈刪除",
	"circles.provider.leave": "你已離開醫療護理圈",
	"circles.family.remove": "此人已從你的家庭圈刪除",
	"circles.family.leave": "你已離開家庭圈",
	"circles.invites.caregiver.error": "被邀請者已是病人的護理員",
	"circles.invites.title": "邀請成員",
	"circles.invites.subtitle": "通過電郵或電話",
	"circles.invites.role": "選擇關係",
	"circles.invites.text.family": "同意邀請你成為他家庭圈的一份子。身為家庭圈的成員你可以接觸個人健康資料，以及與其他家庭圈成員和醫護人員對話。",
	"circles.invites.text.provider": "同意邀請你成為他醫療護理圈的一份子。身為醫療護理圈的成員你可以接觸個人健康資料，以及與其他醫療護理圈成員和病人家屬對話。",
	"circles.invites.text.caregiver": "邀請你擔任護理員。身為護理員你可以為{patient}答計劃內的問卷，更改個人資料及以{patient}的名義使用系統。",
	"circles.invites.text.ProviderInvitesCaregiver": "邀請你擔任{brandName}病人{patientName}的護理員。身為護理員你可以為{patientName}答問卷，及以{patientName}的名義使用{brandName}. 你同意擔任{patientName}的護理員。",
	"circles.invites.makeInviteToFamilyText": "你所邀請的家庭成員將可以接觸你的個人健康資料，以及與其他家庭圈成員和醫護人員對話。",
	"circles.invites.makeInviteProviderText": "你所邀請的醫護人員將可以接觸個人健康資料，以及與其他醫療護理圈成員和病人家屬對話。",
	"circles.invites.makeInviteCaregiverText": "護理員可以為你答計劃內的問卷, 更改你的個人資料及以你的名義使用系統",
	"circles.invites.pending": "待定邀請",
	"circles.invites.caregiver": "護理員可以為病人答計劃內的問卷, 更改病人資料及以病人名義使用系統",
	"circles.circle": "圈",
	"circles.circle.typedCircle": "{type}圈",
	"circles.titles.invitations": "邀請",
	"circles.titles.listCaregiver": "你是下列病人的護理員",
	"circles.titles.familyMemberingCircle": "你的家庭圈",
	"circles.titles.listFamilyCircleMember": "家庭圈",
	"circles.titles.listProviderMember": "你是下列醫療護理圈成員",
	"circles.titles.familyCircle": "家庭圈",
	"circles.titles.providerCircle": "醫療護理圈",
	"circles.titles.primaryProviderProfileTitle": "我的醫療護理圈",
	"circles.titles.primaryPatientProfileTitle": "我的家庭圈",
	"circles.titles.caregiverRole": "護理員",
	"circles.titles.careProvider": "醫療護理人員",
	"circles.family.cancelInvite.title": "你確定要取消家庭圈的邀請?",
	"circles.family.cancelInvite.text": "你將要取消邀請你{role}加入家庭圈。邀請是在{login}送出. 一旦取消邀請便即作廢。",
	"circles.caregiver.cancelInvite.title": "你確定要取消護理員的邀請?",
	"circles.caregiver.cancelInvite.text": "你將要取消你{role}成為你護理員的邀請。 一旦取消邀請便即作廢。",
	"circles.actions.leave": "離開圈",
	"circles.actions.leaveBtn": "離開圈",
	"circles.actions.makeCaregiver": "分派護理員任務",
	"circles.actions.removeCaregiver": "取消護理員任務",
	"circles.actions.removeFromCircle": "從圈內刪除",
	"circles.actions.inviteProvider": "邀請醫療護理人員",
	"circles.actions.inviteFamily": "邀請家庭成員",
	"circles.leave.family.title": "你確定要離開這圈?",
	"circles.leave.family.body": "你將要離開{patient}的家庭圈. 一旦離開你將不能查看{patient}的個人資料。",
	"circles.leave.provider.title": "你確定要離開這圈?",
	"circles.leave.provider.body": "你將要離開{provider}的醫療護理圈. 一旦離開你將不能查看{provider}的圈內資料。",
	"circles.roles.spouse": "配偶",
	"circles.roles.daughter": "女兒",
	"circles.roles.son": "兒子",
	"circles.roles.sister": "姐妹",
	"circles.roles.brother": "兄弟",
	"circles.roles.mother": "母親",
	"circles.roles.father": "父親",
	"circles.roles.granddaughter": "孫女",
	"circles.roles.grandson": "孫子",
	"circles.roles.grandmother": "祖母/外祖母",
	"circles.roles.grandfather": "祖父/外祖父",
	"circles.roles.partner": "伴侶",
	"circles.roles.guardian": "監護人",
	"circles.roles.relative": "親戚",
	"circles.roles.friend": "朋友",
	"circles.roles.power_of_attorney": "授權人",
	"circles.roles.patient": "病人",
	"circles.roles.caregiver": "護理員",
	"circles.roles.left_the_circle": "已離開圈",
	"circles.roles.single_care_provider": "單一醫療護理人員",
	"circles.roles.family_member": "家庭成員",
	"circles.addProviderReason.temporaryTitle": "臨時使用",
	"circles.addProviderReason.permanentTitle": "永久分派",
	"circles.addProviderReason.temporary.emergencyAccess": "緊急使用",
	"circles.addProviderReason.temporary.temporarilyAssigned": "暫時分派",
	"circles.addProviderReason.temporary.patientConsultation": "會診",
	"circles.addProviderReason.permanent.underTreatment": "接受治療中",
	"circles.addProviderReason.permanent.patientRequest": "病人請求",
	"communities.empty.navigation": "沒有社區可供瀏覽",
	"communities.empty": "你未有社區",
	"communities.title.member": "我的社區",
	"communities.title.moderator": "我是論壇管理",
	"community.type.public": "大眾社區",
	"community.type.private": "私人社區",
	"community.type.global": "全球社區",
	"community.access.readOnly": "只讀",
	"community.actions.createPost": "新帖",
	"community.empty": "沒有這社區",
	"community.description": "關於",
	"community.posts": "新近帖子",
	"community.posts.empty": "還沒有帖子",
	"community.members": "成員",
	"community.postUpdated": "已更新",
	"community.activity.total": "你有{posts}個新帖和{comments}新評語",
	"community.activity.posts": "你有{posts}個新帖",
	"community.activity.comments": "你有{comments}個新評語",
	"post.title": "留下評語",
	"post.back": "返回帖子",
	"post.comments": "評語",
	"post.comments.add": "留下評語",
	"post.actions.createComment": "留下評語",
	"post.actions.reply": "回應",
	"post.comment.description": "已留下評語",
	"post.replies": "回應",
	"post.reply.description": "已回應{name}的評語",
	"post.reply.placeholder": "回應評語...",
	"post.comments.empty": "沒有評語",
	"community.newPost.title": "{name}社區新帖",
	"community.newPost.edit.title": "更改{name}社區帖子",
	"community.newPost.caption": "標題",
	"community.newPost.attachImage": "附帶圖片",
	"community.newPost.attachURL": "附帶連結",
	"community.newPost.addPost": "開帖",
	"community.newPost.editPost": "更改帖子",
	"community.newPost.fileError": "圖片限{size}mb以下",
	"community.newPost.urlError": "連結無效",
	"community.newPost.noPreview": "不能預覽",
	"community.newPost.enterUrl": "輸入網址...",
	"community.postMenu.editPost": "更改帖子",
	"community.postMenu.deletePost": "刪除帖子",
	"community.postMenu.confirmDeleteMessage": "你確定要刪除這帖子? 一旦刪除便不能再收復",
	"community.commentMenu.editComment": "更改評語",
	"community.commentMenu.deleteComment": "刪除評語",
	"community.commentMenu.confirmDeleteComment": "你確定要刪除這評語? 一旦刪除便不能再收復",
	"community.comments.commentWasDeleted": "評語已刪除",
	"community.comments.commentWasDeletedByModerator": "評語被論壇管理刪除",
	"community.roles.moderator": "論壇管理",
	"community.roles.member": "成員",
	"profile.fieldSet.empty": "這欄目沒有資料。 更改欄目加入資料。",
	"profiles.updated": "個人資料已更改",
	"settings.updated": "設定已更改",
	"programs.title": "計劃",
	"programs.emptyState": "還未沒有分派到任何計劃",
	"programs.invitation.emptyState": "沒有任何計劃給",
	"programs.invitation.addPatient": "加病人到計劃",
	"programs.invitation.invitationText": "邀請你加入計劃/服務",
	"programs.invitation.title": "{user}的計劃/服務邀請",
	"programs.invitation.empty": "你沒有計劃/服務的邀請",
	"programs.invitation.success": "病人成功地加入計劃",
	"programs.actions.request": "計劃/服務邀請",
	"programs.actions.title": "{user}的計劃/服務細節",
	"programs.actions.followup": "{user}的預約跟進",
	"programs.actions.subtitle": "關於這計劃/服務",
	"programs.actions.showMore": "顯示更多",
	"programs.actions.showLess": "顯示較少",
	"programs.actions.leave": "離開計劃/服務",
	"programs.actions.aboutProgram": "關於這計劃",
	"programs.remove.confirmRemove": "你確定要從{program}刪除{patientName}?",
	"programs.remove.success": "病人已從計劃中刪除",
	"programs.remove.title": "從計劃中刪除病人",
	"programs.remove.subtitle": "離開這計劃",
	"surveys.noUpcomingSurveys": "你沒有未答的問卷",
	"surveys.noSurveysResults": "沒有問卷結果",
	"surveys.sent": "問卷已送出",
	"surveys.answer": "問卷已答",
	"surveys.actions.answer": "答問卷",
	"surveys.actions.save": "保存草稿",
	"surveys.actions.proceed": "繼續",
	"surveys.actions.general": "服務滿意度",
	"surveys.actions.review": "回顧",
	"surveys.actions.submit": "提交答案",
	"surveys.actions.upcoming": "新問卷",
	"surveys.actions.upcomingHeading": "{user}的新問卷",
	"surveys.sendSurvey.noSurveys": "沒有問卷可送",
	"surveys.actions.exportToPDF": "轉換成PDF",
	"surveys.title": "問卷",
	"surveys.results": "問卷結果",
	"surveys.single": "問卷",
	"surveys.totalScore": "總分",
	"surveys.selectedChatDesc": "所選對話的成員皆可讀這問卷",
	"surveys.answeredBy": "回答者",
	"surveys.answerForm": "問卷已被答",
	"surveys.noAvailableForms": "沒有問卷",
	"profile.actions.cancel": "丟棄",
	"profile.actions.details": "查看個人資料細節",
	"profile.actions.submit": "保存",
	"profile.actions.provider": "醫療護理人員",
	"profile.actions.patient": "病人",
	"profile.actions.back": "病人的主版",
	"profile.avatar.remove": "刪除",
	"profile.avatar.upload": "上傳照片",
	"profile.avatar.update": "更新照片",
	"profile.tabType.patient": "用戶個人資料",
	"profile.tabType.provider": "醫療護理人員資料",
	"profile.tabType.surveys": "一般問卷",
	"profile.section.general": "一般資料",
	"profile.section.personal": "個人資料",
	"profile.section.contacts": "聯絡資料",
	"profile.section.health": "健康資料",
	"profile.section.prof": "職業資料",
	"profile.section.mrns": "病歷號碼",
	"profile.section.address": "住址",
	"profile.section.notificationSettings": "通知設定",
	"profile.section.languageSettings": "語言設定",
	"profile.fields.bio": "個人簡歷",
	"profile.fields.location": "地點",
	"profile.fields.phones": "電話",
	"profile.fields.healthInterests": "健康興趣",
	"profile.fields.name": "姓名",
	"profile.fields.firstName": "名",
	"profile.fields.middleName": "中間名",
	"profile.fields.lastName": "姓",
	"profile.fields.gender": "性別",
	"profile.fields.dob": "出生日期",
	"profile.fields.race": "種族",
	"profile.fields.mStatus": "婚姻狀況",
	"profile.fields.ethnic": "族群",
	"profile.fields.language": "語言",
	"profile.fields.religion": "宗教",
	"profile.fields.email": "電郵地址",
	"profile.fields.homeAddress": "住址",
	"profile.fields.address1": "地址 1",
	"profile.fields.address2": "地址 2",
	"profile.fields.city": "城市",
	"profile.fields.state": "州",
	"profile.fields.postalCode": "郵區",
	"profile.fields.country": "國家",
	"profile.fields.homePhone": "家庭電話號碼",
	"profile.fields.mobilePhone": "手機電話號碼",
	"profile.fields.localUid": "病歷號碼 (MRN)",
	"profile.fields.allergies": "敏感",
	"profile.fields.medicine": "藥物治療",
	"profile.fields.healthGoals": "健康目標",
	"profile.fields.role": "Role",
	"profile.fields.mrns": "病歷號碼",
	"profile.fields.localUidProvider": "醫療護理人員號碼",
	"profile.fields.npi": "醫療護理人員 NPI",
	"profile.fields.title": "Title",
	"profile.fields.specialty": "專業",
	"profile.fields.primaryPracticeAddress": "主要診所地址",
	"profile.fields.primaryPracticeAddress1": "主要診所地址 1",
	"profile.fields.primaryPracticeAddress2": "主要診所地址 2",
	"profile.fields.primaryPracticeCity": "主要診所城市",
	"profile.fields.primaryPracticeState": "主要診所州",
	"profile.fields.primaryPracticeCountry": "主要診所國家",
	"profile.fields.officePhone": "辦公室電話",
	"profile.fields.username": "用戶名",
	"profile.fields.phoneNumber": "手機電話號碼",
	"profile.fields.day": "日",
	"profile.fields.year": "年",
	"profile.fields.month": "月",
	"profile.edit.emailConfirmationTitle": "確定聯絡資料",
	"profile.edit.emailConfirmationText": "驗證電郵已送到{email}. 舊的電郵將繼續生效直至驗證成功為止",
	"profile.edit.confirmCode": "驗證碼",
	"profile.edit.invalidCode": "驗證碼無效",
	"profile.edit.phoneConfirmationText": "新電話號碼需要驗證。 一個含驗證碼的短訊已送到{phone}。請把驗證碼輸入。",
	"profile.notificationSettings.label": "採用{type} ({value})通知",
	"profile.notificationSettings.labels.email": "電郵",
	"profile.notificationSettings.labels.sms": "短訊",
	"profile.list.gender.M": "男",
	"profile.list.gender.F": "女",
	"profile.list.gender.O": "其他",
	"profile.list.gender.U": "不詳",
	"profile.list.marital.S": "單身",
	"profile.list.marital.M": "已婚",
	"profile.list.marital.O": "其他",
	"profile.list.marital.U": "不詳",
	"chat.common.removeFromChat": "從對話中刪除",
	"chat.actions.downloadAttachment": "下載附件",
	"chat.actions.editMessage": "更改訊息",
	"chat.actions.deleteMessage": "刪除訊息",
	"chat.actions.confirmDeleteMessage": "你確定要刪除訊息? 一旦刪除不能收復",
	"chat.actions.confirmLeaveChat": "你確定要離開對話嗎？",
	"chat.actions.reply": "回覆",
	"chat.actions.blockMessaging": "封鎖訊息",
	"chat.actions.unblockMessaging": "解除訊息封鎖",
	"chat.actions.unblockUser": "解除用戶封鎖",
	"chat.actions.leaveChat": "離開對話",
	"chat.titles.uploadingFile": "你在上載檔案 {name}",
	"chat.titles.generalChatTab": "醫療護理圈",
	"chat.titles.familyChatTab": "家庭專用",
	"chat.titles.providersChatTab": "醫護專用",
	"chat.titles.activitiesChatTab": "活動",
	"chat.titles.notificationsChatTab": "通知/警告",
	"chat.titles.healthAlert": "健康警告",
	"chat.titles.providerAssignment": "醫療護理人員分派",
	"chat.titles.providerRemoved": "刪除醫療護理人員分派",
	"chat.titles.memberAssignment": "成員分派",
	"chat.titles.notification": "通知",
	"chat.titles.surveyReminder": "提醒",
	"chat.titles.addedAttachment": "加入附件",
	"chat.titles.providers": "醫療護理人員",
	"chat.titles.family": "家庭",
	"chat.title.chatInContextOf": "對話圍繞著",
	"chat.title.inContextOf": "圍繞著",
	"chat.title.conversationInfo": "對話資料",
	"chat.title.chatName": "對話名",
	"chat.title.userBlocked": "你被對方封鎖，不能與他對話",
	"chat.placeholders.messageTo": "收信人",
	"chat.placeholders.default": "請輸入訊息",
	"chat.placeholders.surveyExpired": "這問卷已過期",
	"chat.notifications.patientAssignedToProgram": "{organizationName}的{providerName}已替{patientName}註冊到{programName}計劃/服務",
	"chat.notifications.patientRemovedFromProgram": "已從{programName}計劃/服務中刪除{patientName}",
	"chat.sorting.byUnread": "以最多未讀訊息排列",
	"chat.sorting.byLastMessage": "以最後訊息排列",
	"chat.errors.tooLong": "限{length}字",
	"chat.errors.maxAttachmentSize": "限50Mb已下",
	"chat.errors.maxAttachmentSizeNextPart": "檔案太大",
	"chat.errors.notAllowedFormat": "只可以上載 jpg, png, pdf, docx, xlsx, pptx, rtf, txt, xml, mov, mp4 和 vcf 檔案",
	"chat.errors.uploadError": "上載失誤。請再嘗試",
	"chat.errors.maxAttachmentNumber": "限每次上載20個檔案",
	"chat.moreAttachments.sendSurvey": "送出問卷",
	"chat.moreAttachments.answerForm": "答問卷",
	"chat.moreAttachments.attachFile": "加附件",
	"chat.notification.newMessage": "新訊息",
	"auth.accessDenied.text": "對不起，你沒有權限進入。",
	"auth.createPassword.text": "請輸入新密碼",
	"auth.expiredToken.text": "註冊連結有七天限期，而且只可用一次。",
	"auth.expiredConfirmation.text": "確認連結有七天限期，而且只可用一次。",
	"auth.recoverConfirm.email.title": "我們已把收復的步驟送到你的電郵。",
	"auth.recoverConfirm.email.confirmText": "請查看你的電郵。",
	"auth.recoverConfirm.phone.title": "我們已把收復的步驟傳送到你的電話。",
	"auth.recoverConfirm.phone.confirmText": "請查看你的電話。",
	"auth.recoverPassword.textTitle": "請輸入你的電郵地址或電話號碼，我們告知收復密碼的方法。",
	"auth.recoverPassword.textLink": "忘記密碼?",
	"auth.userNotFound.text": "沒有用這電郵/電話的用戶",
	"auth.signup.title": "沒有戶口?",
	"auth.signup.textLink": "註冊{brandName}",
	"auth.tnc.title": "我有閱讀並同意",
	"auth.tnc.textLink": "服務條款",
	"auth.logout.text": "登出",
	"errors.common": "有些地方出錯了...",
	"errors.commonErrorOccured": "發生了故障，請稍後再試",
	"errors.emailError": "請輸入正確電郵地址",
	"errors.emailErrorDesription": "登入 {故障}",
	"errors.invalidDateOfBirth": "請輸入正確出生日期",
	"errors.login.unauthorized": "戶口或密碼不符",
	"errors.login.authenticationLockout": "戶口暫時關閉15分鐘。請稍後再試",
	"errors.nameLength": "姓和名各限40字",
	"errors.requiredFields": "必須填寫所有項目",
	"errors.tnc": "請確認你已閱讀並同意所有服務條款。",
	"errors.cannotAcceptInvite": "你需要先輸入個人資料才能加入家庭圈",
	"errors.nicknameContainsCommercialAt": "你才不可以有@符號",
	"errors.password": "密碼不可以空白或全是空格",
	"errors.validation.profile.firstName.required": "必須填寫名",
	"errors.validation.profile.lastName.required": "必須填寫姓",
	"errors.validation.profile.phone.format": "電話號碼只限 +, - 和數字",
	"errors.validation.profile.phone.required": "必須填寫電話號碼",
	"errors.validation.profile.dob.format": "日期格式不對",
	"errors.validation.profile.dob.required": "必須填寫出生日期",
	"errors.validation.profile.email.format": "請填寫正確的電郵地址",
	"errors.validation.profile.email.required": "必須填寫電郵地址",
	"errors.validation.profile.username.required": "必須填寫用戶名",
	"errors.validation.profile.username.format": "用戶名只限字母和數字",
	"errors.username.alreadyTaken": "用戶名已被佔用",
	"fields.dob": "出生日期",
	"fields.email": "電郵",
	"fields.gender": "性別",
	"fields.firstname": "名",
	"fields.lastname": "姓",
	"fields.password": "密碼",
	"fields.username": "暱稱",
	"fields.login": "用戶名",
	"fields.login.placeholder": "電郵地址或電話號碼",
	"fields.phoneNumber": "電話號碼",
	"submit.signup": "繼續",
	"submit.login": "登錄",
	"submit.fillProfile": "確認",
	"submit.recoverPassword": "提交要求",
	"submit.recoverConfirm": "回到登錄",
	"submit.createPassword": "保存密碼",
	"submit.expiredToken": "知道了",
	"titles.accessDenied": "拒絕進入",
	"titles.createPassword": "設定密碼",
	"titles.expiredToken": "注册連結已失效",
	"titles.expiredConfirmation": "確認連結已失效",
	"titles.fillProfile": "個人資料",
	"titles.login": "登錄{brandName}",
	"titles.recoverConfirm": "收復連結已送出",
	"titles.recoverPassword": "收復密碼",
	"titles.signup": "注册{brandName}",
	"titles.confirmMyPhoneNumber": "我確認我的電話號碼",
	"titles.confirmMyEmail": "我確認我的電郵地址",
	"general.careProvidersTitle": "醫療護理人員",
	"previewableBlock.more": "顯示更多",
	"previewableBlock.less": "顯示較少",
	"generalSurveys.noSurveys": "你沒有服務滿意度資料",
	"intro.common.logout": "登出",
	"intro.common.circlesMenu": "邀請別人加入圈內",
	"intro.circles.inviteFamilyMember": "邀請別人加入家庭圈",
	"intro.circles.assignCaregiver": "分派別人為護理員。 護理員能以病人名義使用軟件",
	"intro.circles.inviteProviderMember": "邀請醫療護理人員加入圈內",
	"intro.circles.removeProviderMember": "從醫療護理圈中刪除人員",
	"intro.messages.generalChannel": "點擊標簽來與所有醫護人員和家人對話",
	"intro.messages.providerChannel": "與醫療護理人員的私人對話",
	"intro.messages.familyChannel": "與病人家屬的私人對話",
	"intro.messages.searchChat": "尋找對話",
	"intro.messages.selectChat": "選擇對話",
	"intro.messages.selectChannel": "選擇渠道",
	"intro.messages.typeFilter": "選擇對話了類別",
	"intro.messages.typeMessage": "請輸入訊息",
	"intro.messages.answerSurvey": "點擊然後回答問卷",
	"intro.messages.patientName": "點擊病人名字以查看醫療護理人員和計劃",
	"intro.messages.patientContext": "下列皆是這病人的資料",
	"intro.messages.patientProgram": "點擊以查看病人計劃",
	"intro.messages.programFilter": "篩選病人",
	"notificationScreen.title": "通知",
	"notificationScreen.providerWithoutPatients.notification": "圈子只為病人和家屬而設。",
	"notificationScreen.providerWithoutPatients.instructionTitle": "在{brandName}裡如何成為病人或家屬（護理員）?",
	"notificationScreen.providerWithoutPatients.instructionBody": "若想成為用戶，請詢問你的醫生是否已在{brandName}註冊。若已註冊可請他把你加入{brandName}的護理計劃。然後你可以邀請你的家屬加入你的護理圈。若想成為病人家屬用戶（護理員），請病人現有的家屬用戶邀請你到他的家庭圈。",
	"notificationScreen.providerWithoutPatients.commonTitle": "已經是病人或家屬?",
	"notificationScreen.providerWithoutPatients.commonBody": "如果你的醫生已替你加入了計劃，但你還沒有主版，嘗試更新你的電郵地址。",
	"routes.patientViewProfile": "病人個人資料",
	"routes.providerViewProfile": "醫療護理人員個人資料",
	"routes.userViewProfile": "用戶個人資料",
	"routes.providerMemberProfile": "醫療護理圈成員個人資料",
	"routes.familyMemberProfile": "病人家屬個人資料",
	"routes.generalSurveys": "一般問卷",
	"routes.parentProvider": "主要醫療護理人員",
	"routes.patientInfo": "病人資料",
	"routes.providerInfo": "醫療護理人員資料",
	"routes.settings": "設定",
	"role.admin": "管理",
	"dialog.common.invite": "邀請更多人加入對話",
	"dialog.success.joinCircle": "你已加入病人的醫療護理圈",
	"dialog.titles.joinCircle": "加入病人的醫療護理圈",
	"dialog.titles.assignProviderToPatient": "給病人分派新醫療護理人員",
	"dialog.common.noPatients": "如尋找不到病人，他可能不在系統之中或者已經分派給你。",
	"dialog.common.assign": "分派",
	"dialog.common.addPatient": "加入病人",
	"dialog.common.defaultPatient": "如要加入病人的醫療護理圈，請輸入病人的用戶或姓名",
	"dialog.common.addNewPatient": "加入新病人",
	"dialog.common.defaultProvider": "如要分派醫護人員給病人，請輸入醫護人員的用戶或姓名",
	"dialog.common.assignProvider": "分派醫療護理人員",
	"dialog.common.inviteCaregiver": "邀請護理員",
	"dialog.common.searchProvider": "尋找醫護人員...",
	"dialog.common.searchPatient": "尋找病人...",
	"dialog.common.addAnotherPatient": "你想加另一個病人入系統嗎?",
	"dialog.titles.addPatient": "加病人",
	"dialog.titles.andOr": "和 / 或"
};


//////////////////
// WEBPACK FOOTER
// ./src/translations/zh.json
// module id = 5359
// module chunks = 39